<template>
    <div class="Merchants_box no-trans" v-loading="loading">
        <div class="banner_box">
            <div class="banner_title">
                诚邀全国城市区域合伙人
            </div>
            <div class="banner_text">
                国内首家登陆央坝的法律电商品牌，已获知名风投天使轮/A轮投资
                    创新的“互联网+法律”—站式企业法律顾问模式
                    服务客户30000+，覆盖全国100+个城市和地区
            </div>
            <div class="banner_btns">
                <div class="btns">申请加盟</div>
            </div>
        </div>
        <div class="process">
            <div class="process_box">
                <div class="process_title">加盟流程</div>
                <div class="process_borders"></div>
                <div class="process_list">
                    <div class="items" v-for="(item,index) in lc_lis" :key="index">
                        <div class="item_img">
                            <img :src="item.imgs" alt="">
                        </div>
                        <div class="item_title">{{item.title}}</div>
                        <div class="item_borders"></div>
                        <div class="item_const">{{ item.const }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form_add">
            <div class="form_add_box">
                <div class="form_lefts">
                    <div class="form_title">加盟条件</div>
                    <div class="form_borders"></div>
                    <div class="form_const">
                        具有承担民事责任能力的公司或者个人
                        具有一定的社会资源关系和启动资金
                        认同法律点评网的经营模式以及经营理念
                        征信状况良好，近五年内无失信记录
                        有销售团队管理经验
                    </div>
                    <div class="form_phone">
                        <img src="../../../assets/img/index/Merchants/phone.png" alt="">
                        加盟热线：{{ $store.state.vuex_setting.site_tel }}
                    </div>
                </div>
                <div class="form_rights">
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>姓名</div>
                        <div class="form_input1">
                            <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>手机号</div>
                        <div class="form_input1">
                            <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>电子邮箱</div>
                        <div class="form_input1">
                            <el-input v-model="form.email" placeholder="请输入电子邮箱"></el-input>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>所在地区</div>
                        <div class="form_input2">
                            <el-cascader placeholder="请选择城市名称" clearable v-model="area_ac" :options="area_list"  :props="props"></el-cascader>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>身份证号</div>
                        <div class="form_input1">
                            <el-input v-model="form.identity" placeholder="请输入身份证号"></el-input>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span> 资格证号</div>
                        <div class="form_input1">
                            <el-input v-model="form.certify" placeholder="请输入资格证号"></el-input>
                        </div>
                    </div>

                    <div class="form_flex">
                        <div class="form_title">留言</div>
                        <div class="form_input3">
                            <el-input type="textarea" v-model="form.content" placeholder="请输入留言内容"></el-input>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"></div>
                        <div class="form_input4">
                          <div class="btns" @click="handle_end">提交信息</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
 
export default {
    components: {
       
    },
    name: "homes",
    data() {
        return {
            loading:false,
            form:{
                name:'',//姓名
                phone:'',//手机号
                email:'',//邮箱
                province:'',//省
                city:'',//市
                area:'',//区
                identity:'',//身份证号
                certify:'',//资格证号
                content:'',//留言
            },
            area_list: [],
            area_ac:[],
            props:{
                label:'name',
                value:'id',
                children:'children',
            },
            lc_lis:[
                {
                    imgs:require('../../../assets/img/index/Merchants/icon1.png'),
                    title:'前期沟通',
                    const:'在线填写加盟意见致电加盟服务热线',
                },
                {
                    imgs:require('../../../assets/img/index/Merchants/icon2.png'),
                    title:'电联沟通',
                    const:'提出需求，洽谈细节达成一致',
                },
                {
                    imgs:require('../../../assets/img/index/Merchants/icon3.png'),
                    title:'面谈参考',
                    const:'提出需求，洽谈细节达成一致',
                },
                {
                    imgs:require('../../../assets/img/index/Merchants/icon4.png'),
                    title:'正式签约加盟',
                    const:'签约加盟签约加盟签约加盟',
                }
            ],
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {
        this.get_area()

    },
    methods: {
        get_area(){
            this.$api("getChinaArea", {
                parent_id:1,
				type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.area_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_end(){
            if(!this.form.name){
                alertErr('请输入姓名')
                return
            }
            if(!this.form.phone){
                alertErr('请输入手机号')
                return
            }
            let reg = /^((11[0-9])|(12[0-9])|(13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
            if (!reg.test(this.form.phone)) {
                alertErr('请输入正确的手机号')
                return 
            }
            if(!this.form.email){
                alertErr('请输入电子邮箱')
                return
            }
            if(this.area_ac.length==0){
                alertErr('请选择所在地区')
                return
            }
            if(!this.form.identity){
                alertErr('请输入身份证号')
                return
            }
            if(!this.form.certify){
                alertErr('请输入资格证号')
                return
            }
            this.form.province=this.area_ac[0]
            this.form.city=this.area_ac[1]
            this.form.area=this.area_ac[2]
            this.loading=true
            this.$api("attractJoin", {
                type:2,
                ...this.form
			}, "POST").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    alertSucc('提交成功')
                     this.form={
                        name:'',//姓名
                        phone:'',//手机号
                        email:'',//邮箱
                        province:'',//省
                        city:'',//市
                        area:'',//区
                        identity:'',//身份证号
                        certify:'',//资格证号
                        content:'',//留言
                     }
                     this.area_ac=[]
                } else {
                    alertErr(res.msg)
                }
            });
        },


    },

}
</script>
<style scoped lang="less">
.Merchants_box {
    padding-bottom: 100px;
    background: #F5F5F5;
   .banner_box{
        width: 100%;
        height: 480px;
        background-size: 100%;
        background-image: url('../../../assets/img/index/Merchants/banners.png');
        .banner_title{
            padding-top: 78px;
            text-align: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 46px;
            color: #FFFFFF;
        }
        .banner_text{
            width: 524px;
            margin: auto;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 18px;
            color: #FFFFFF;
            text-align: center;
            padding-top: 56px;
            line-height: 40px;
        }
        .banner_btns{
            display: flex;
            justify-content: center;
            padding-top: 64px;
            .btns{
                width: 180px;
                height: 40px;
                background: #377CFD;
                border-radius: 4px 4px 4px 4px;
                text-align: center;
                line-height: 40px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 16px;
                color: #FFFFFF;
                cursor: pointer;

            }
        }
   }
   .process{
        background-color: #FFFFFF;
        height: 570px;
        width: 100%;
        .process_box{
            width: 1440px;
            margin: auto;
            .process_title{
                padding-top: 80px;
                text-align: center;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 36px;
                color: #333333;

            }
            .process_borders{
                width: 80px;
                height: 6px;
                background: #377CFD;
                border-radius: 3px 3px 3px 3px;
                margin: auto;
                margin-top: 24px;
            }
            .process_list{
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 120px;
                margin-top: 70px;
                .items{
                    width: 220px;
                    height: 260px;
                    background: #FFFFFF;
                    border-radius: 8px 8px 8px 8px;
                    // text-align: center;
                    padding: 20px 38px;
                    .item_img{
                        width: 80px;
                        height: 80px;
                        margin: auto;
                        img{
                            width: 80px;
                            height: 80px;
                        }
                    }
                    .item_title{
                        text-align: center;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 24px;
                        color: #333333;
                        padding-top: 19px;
                    }
                    .item_borders{
                        width: 60px;
                        height: 3px;
                        background: #377CFD;
                        border-radius: 3px 3px 3px 3px;
                        margin: 20px auto;
                    }
                    .item_const{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #666666;
                        text-align: center;
                    }

                }

            }
        }
   }
   .form_add{
    padding-top: 80px;
        .form_add_box{
            width: 1440px;
            min-height: 610px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            margin: auto;
            display: flex;
            justify-content: space-between;
            // align-items: center;
            padding: 80px 130px;
            .form_lefts{
                .form_title{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 26px;
                    color: #333333;

                }
                .form_borders{
                    width: 53px;
                    height: 4px;
                    background: #377CFD;
                    border-radius: 4px 4px 4px 4px;
                    margin-top: 16px;
                }
                .form_const{
                    width: 324px;
                    margin-top: 40px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 18px;
                    color: #333333;
                    line-height: 44px;

                }
                .form_phone{
                    display: flex;
                    align-items: center;
                    margin-top: 56px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 20px;
                    color: #377CFD;


                    img{
                        width: 26px;
                        margin-right: 19px;
                    }
                }
            }
            .form_rights{
                .form_flex{
                    display: flex;
                    // align-items: center;
                    margin-bottom: 20px;
                    .form_title{
                        width: 200px;
                        padding-right: 24px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        text-align: right;
                        line-height: 40px;
                        span{
                            color: #FD4C5C;
                        }
                    }
                    .form_input1{
                        width: 480px;
                        flex-shrink: 0;
                    }
                    .form_input2{
                        width: 480px;
                        flex-shrink: 0;
                        /deep/.el-cascader{
                            width: 100%;
                        }
                    }
                    .form_input3{
                        width: 480px;
                        flex-shrink: 0;
                    }
                    .form_input4{
                        width: 480px;
                        flex-shrink: 0;
                        padding-top: 40px;
                        .btns{
                            width: 480px;
                            height: 50px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px; 
                            text-align: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 18px;
                            color: #FFFFFF;
                            line-height: 50px;
                            cursor: pointer;
                        }   
                    }
                }
            }
        }
   }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .Merchants_box.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-bottom: 16px;
    }
    .Merchants_box.no-trans .banner_box {
        min-height: 0;
        height: auto;
    }
    .Merchants_box.no-trans .banner_box .banner_title {
        padding-top: 16px;
        font-size: 24px;
    }
    .Merchants_box.no-trans .banner_box .banner_text {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
        font-size: 18px;
        padding-top: 16px;
        line-height: 40px;
    }
    .Merchants_box.no-trans .banner_box .banner_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .Merchants_box.no-trans .banner_box .banner_btns .btns {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 16px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .Merchants_box.no-trans .process {
        min-height: 0;
        height: auto;
    }
    .Merchants_box.no-trans .process .process_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .Merchants_box.no-trans .process .process_box .process_title {
        padding-top: 16px;
        font-size: 24px;
    }
    .Merchants_box.no-trans .process .process_box .process_borders {
        width: 80px;
        height: 6px;
        border-radius: 3px 3px 3px 3px;
        margin: auto;
        margin-top: 16px;
    }
    .Merchants_box.no-trans .process .process_box .process_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 0 16px;
        margin-top: 16px;
    }
    .Merchants_box.no-trans .process .process_box .process_list .items {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        padding: 16px 16px;
    }
    .Merchants_box.no-trans .process .process_box .process_list .items .item_img {
        width: 80px;
        height: 80px;
        margin: auto;
    }
    .Merchants_box.no-trans .process .process_box .process_list .items .item_img img {
        width: 80px;
        height: 80px;
    }
    .Merchants_box.no-trans .process .process_box .process_list .items .item_title {
        font-size: 24px;
        padding-top: 16px;
    }
    .Merchants_box.no-trans .process .process_box .process_list .items .item_borders {
        width: 60px;
        height: 3px;
        border-radius: 3px 3px 3px 3px;
        margin: 16px auto;
    }
    .Merchants_box.no-trans .process .process_box .process_list .items .item_const {
        font-size: 16px;
    }
    .Merchants_box.no-trans .form_add {
        padding-top: 16px;
    }
    .Merchants_box.no-trans .form_add .form_add_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        margin: auto;
        flex-wrap: wrap;
        gap: 8px;
        padding: 16px 16px;
    }
    .Merchants_box.no-trans .form_add .form_add_box .form_lefts .form_title {
        font-size: 24px;
        width: 100%;
        text-align: left;
        line-height: 1.6;
        padding: 0;
    }
    .Merchants_box.no-trans .form_add .form_add_box .form_lefts .form_borders {
        width: 53px;
        height: 4px;
        border-radius: 4px 4px 4px 4px;
        margin-top: 16px;
    }
    .Merchants_box.no-trans .form_add .form_add_box .form_lefts .form_const {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin-top: 16px;
        font-size: 18px;
        line-height: 44px;
    }
    .Merchants_box.no-trans .form_add .form_add_box .form_lefts .form_phone {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-top: 16px;
        font-size: 20px;
    }
    .Merchants_box.no-trans .form_add .form_add_box .form_lefts .form_phone img {
        width: 26px;
        margin-right: 16px;
    }
    .Merchants_box.no-trans .form_add .form_add_box .form_rights .form_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 16px;
        flex-direction: column;
        align-items: stretch;
    }
    .Merchants_box.no-trans .form_add .form_add_box .form_rights .form_flex .form_title {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        padding-right: 16px;
        font-size: 14px;
        line-height: 1.6;
        text-align: left;
        padding: 0;
    }
    .Merchants_box.no-trans .form_add .form_add_box .form_rights .form_flex .form_input1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .Merchants_box.no-trans .form_add .form_add_box .form_rights .form_flex .form_input2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .Merchants_box.no-trans .form_add .form_add_box .form_rights .form_flex .form_input3 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .Merchants_box.no-trans .form_add .form_add_box .form_rights .form_flex .form_input4 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        padding-top: 16px;
    }
    .Merchants_box.no-trans .form_add .form_add_box .form_rights .form_flex .form_input4 .btns {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 18px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
